import { render } from "./MetricsSystem.vue?vue&type=template&id=3225660e&scoped=true"
import script from "./MetricsSystem.vue?vue&type=script&lang=js"
export * from "./MetricsSystem.vue?vue&type=script&lang=js"

import "./MetricsSystem.vue?vue&type=style&index=0&id=3225660e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3225660e"]])

export default __exports__